export const MODAL_WRAPPER_SELECTOR = '.boost-sd__modal-wrapper';
export const RECOMMENDATION_SELECTOR = '.boost-sd__recommendation';
export const VOLUME_RADIO_SELECTOR = '.boost-sd__volume-bundle-menu-radio';
export const VOLUME_RADIO_LABEL_SELECTOR = '.boost-sd__volume-bundle-menu-label';
export const VOLUME_MENU_SELECTOR = '.boost-sd__volume-bundle-menu';
export const VOLUME_MENU_ITEM_SELECTOR = '.boost-sd__volume-bundle-menu-item';
export const VOLUME_BUTTON_ADD_BUNDLE_TO_CART_SELECTOR =
  '.boost-sd__volume-bundle-menu-add-to-cart';
export const VOLUME_BUNDLE_BLOCK_SELECTOR = '.boost-sd__widget-volume-bundle';
export const DROPDOWN_ITEM_SELECTOR = '.boost-sd__dropdown-volume-item';
export const PRE_FIX_CLASS_VOLUME_BUNDLE_MODAL = 'boost-sd__volume-bundle-modal-';
export const VOLUME_BUNDLE_ID_CONTAINER_PRODUCT = 'boost-sd__volume-bundle-product';
export const VOLUME_RADIO_CHECKED = 'boost-sd__volume-bundle-menu-radio--checked';
export const DROPDOWN_LIST = 'boost-sd__dropdown-option-list';
export const DROPDOWN_LIST_OPEN = 'boost-sd__dropdown-option-list--open';
export const DROPDOWN_SELECT_OPTION = 'boost-sd__dropdown-selected-option';
export const DROPDOWN_CONTAINER = 'boost-sd__dropdown-volume';
export const DROPDOWN_SELECT_OPTION_SELECTED = 'boost-sd__dropdown-option--selected';
export const VOLUME_BUNDLE_DEFAULT_SETTINGS = {
  bundleBadgeColor: '#111111',
  bundleBadgeText: 'Most popular',
  bundleBadgeTextColor: '#FFFFFF',
  bundleImageData: '',
  bundleImageLink: '',
  bundleImageType: 'single',
  titleName: 'Buy more, save more',
  templateType: 'default',
  titleAlignment: 'center',
  titleTextColor: '#3D4246',
  titleFont: 'Poppins',
  titleTextTransform: 'uppercase',
  titleFontStyle: 'regular',
  titleFontSize: 14,
  buttonBackgroundColor: '#111111',
  buttonText: 'Add bundle to cart',
  buttonTextColor: '#FFFFFF',
  description: 'Buy {{quantity}} items and save {{discount}}',
  isDefault: false,
};

export const VOLUME_BUNDLE_NAME_TEMPLATE = {
  bundleBlock: 'recommendationVolumeBundleBlock',
  bundleProduct: 'recommendationVolumeBundleProduct',
  bundlePopup: 'recommendationVolumeBundlePopup',
};
export const VOLUME_BUNDLE_ACTION = {
  initData: 'init-data',
  changeVariant: 'change-variant',
  clickRadio: 'click-radio',
};
export const KEY_VOLUME_BUNDLE_DATA_SESSION = `VolumeBundleDataSession`;
export const KEY_VOLUME_BUNDLE = 'volumeBundleKey';
export const KEY_VOLUME_BUNDLE_OPENING = `VolumeBundleOpening`;
export const KEY_VOLUME_BUNDLE_COMBOBOX_BUTTON = `VolumeBundleComboBox`;
export const KEY_VOLUME_BUNDLE_RADIO = `VolumeBundleRadio`;
